import cls from 'classnames';

// ui
import BlockRenderer from '@/global/BlockRenderer';
import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';
import RichText from '@/molecules/RichText/RichText';
import { DynamicAsset } from '@/molecules/Media/index';
import { isWHEnv } from '@/utils/helper';
import { CtfStoryProductCaptionStyle } from '@/utils/constants';

export default function StoryProduct({
  assets = [],
  entries = [],
  fields = {},
}) {
  const { id, dynamicAssets, content, title, backgroundColor, variant, caption, captionVariant = CtfStoryProductCaptionStyle.BOTTOM_LEFT, useAsHeroImage, hideImageOverlay } = fields;

  return (
    <div
        className={cls(
          'aaco-story aaco-story-product', {
            'py-9': isWHEnv() && variant === "With Border",
            'p-0': isWHEnv() && variant === "Full Bleed",
            [`bg-${backgroundColor}`]: backgroundColor !== undefined,
            'mt-[-76px] md:mt-[-57px]': useAsHeroImage,
          }
        )}
        id={id}
      >
        <div className={cls(
          "container mx-auto flex flex-col relative", {
            "!max-w-full p-0 !m-0": variant === "Full Bleed"
          }
        )}>
          {/* START: image */}
          <div className={cls("aaco-header__image w-full !h-full aspect-[4/5] md:!h-auto md:aspect-auto", {
            "brightness-[0.55]": !hideImageOverlay,
          })}>
            <DynamicAsset
              assets={assets}
              entries={entries}
              title={title}
              field={dynamicAssets}
              lightbox
              container="container"
              style="w-full !h-full aspect-[4/5] md:!h-auto md:aspect-auto"
            />
          </div>
          {/* END: image */}

          {/* START: text */}
          {captionVariant == CtfStoryProductCaptionStyle.CENTER && (
            <div className="aaco-story-product__text absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center text-center">
              {caption &&
                caption.content &&
                caption.content.length > 0 &&
                caption.content.map(({ nodeType, content }, index) => (
                  <RichText
                    entries={entries}
                    nodeType={nodeType}
                    content={content}
                    key={index}
                    richTextStyle={{
                      paragraph: {
                        customFont: TEXT_BASE_CLASS['caption'] + 'text-white',
                      },
                    }}
                  />
                ))}
            </div>
          )}
          {captionVariant == CtfStoryProductCaptionStyle.BOTTOM_LEFT && (
            <div
              className={cls(
                'aaco-story-product__text',
                'absolute bottom-[10%]',
              )}
            >
              <BlockRenderer blocks={content} assets={assets} entries={entries} />
            </div>
          )}
          {/* END: text */}
        </div>
      </div>
  );
}
